import Image from "next/image";
import styled from "styled-components";
import { device } from "styles/Breakpoint";
import { Container } from "styles/Common";

interface props {
  data: IProject;
}

function Banner({ data }: props) {
  return (
    <BnSec>
      <Container>
        <Bnr>
          <Image
            src={data.featuredImage}
            layout="fill"
            alt={data.title}
            priority
          />
        </Bnr>
      </Container>
    </BnSec>
  );
}

export default Banner;

const BnSec = styled.section`
  background-color: var(--white);
`;

const Bnr = styled.div`
  position: relative;
  width: 100%;
  height: 500px;
  background-color: #ececec;

  @media ${device.tablet} {
    height: 600px;
  }
  @media ${device.mobileL} {
    height: 400px;
  }
  img {
    object-fit: contain;
  }
`;
